export const TBL_HEADERS = [
  {
    name: "Actions",
    variable: "",
  },
  {
    name: "QC Name",
    variable: "testName",
  },
  {
    name: "Specimen Type",
    variable: "testType",
  },
  {
    name: "QC Level",
    variable: "labId",
  },
  {
    name: "Lot #",
    variable: "resultMethod",
  },
  {
    name: "Lot Expiration",
    variable: "testCode",
  },
];
